export class Message {
  public messageKey: string;
  public messageClass: string;
  public messageAutoCloseAfter: Number;
}
